import { useNavigate } from "react-router-dom";
import VelkieLayout from "../VelkieLayout";
import { useEffect, useState } from "react";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
import { startCase } from "lodash";
import moment from "moment";
const ActivityLog = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [logData, setLogData] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 0,
    hasNextPage: false,
  });
  const myLogData = async (page = 1) => {
    if (loader) return;

    setLoader(true);

    const { status, data: response_users } = await apiGet(
      apiPath.activityLogs,
      { page: page }
    );

    if (status === 200 && response_users?.success) {
      setLogData((prev) =>
        page === 1
          ? response_users.results.data
          : [...prev, ...response_users.results.data]
      );

      setPagination({
        page: response_users.results.page,
        totalPages: response_users.results.totalPages,
        hasNextPage: response_users.results.hasNextPage,
      });
    }

    setLoader(false);
  };

  useEffect(() => {
    myLogData(1);
  }, []);

  return (
    <VelkieLayout>
      <main className="min-h-full-with-header">
        <div data-v-c15fa150 className="pb-20 relative">
          <div data-v-e313196e>
            <header
              data-v-e313196e
              className="h-12 p-3 bg-secondary text-global-font-on-dark text-14 flex items-center justify-center"
            >
              Active Log
              <div
                onClick={() => navigate(-1)}
                className="icon-close text-16 absolute right-4"
              />
            </header>
            <div data-v-e313196e className="p-4">
              <div data-v-e313196e>
                {logData?.map((res) => {
                  return (
                    <div data-v-e313196e className="mb-2 break-all">
                      <div
                        data-v-e313196e
                        className="py-5px px-2 leading-130% text-12 text-global-font-on-light rounded-t-lg success-header"
                      >
                        {moment(res?.createdAt).format("YYYY-MM-DD HH:MM:SS")}
                      </div>
                      <div
                        data-v-e313196e
                        className="p-2 bg-white border-b border-black-300"
                      >
                        <p
                          data-v-e313196e
                          className="text-11 text-global-font-on-light"
                        >
                          Login Status
                        </p>
                        <p
                          data-v-e313196e
                          className="text-base font-bold text-success"
                        >
                          {startCase(res?.activityStatus)}
                        </p>
                      </div>
                      <div
                        data-v-e313196e
                        className="p-2 flex justify-start items-center bg-white border-b border-black-300"
                      >
                        <span
                          data-v-e313196e
                          className="mr-4 w-4/12 text-12 text-global-font-on-light"
                        >
                          IP Address
                        </span>
                        <span
                          data-v-e313196e
                          className="w-8/12 text-12 text-black-600"
                        >
                          {res?.ip}
                        </span>
                      </div>
                      <div
                        data-v-e313196e
                        className="p-2 flex justify-start items-start bg-white border-b border-black-300"
                      >
                        <span
                          data-v-e313196e
                          className="mr-4 w-4/12 text-12 text-global-font-on-light"
                        >
                          ISP
                        </span>
                        <span
                          data-v-e313196e
                          className="w-8/12 text-12 text-black-600"
                        >
                          {res?.isp || "-"}
                        </span>
                      </div>
                      <div
                        data-v-e313196e
                        className="p-2 flex justify-start items-start bg-white rounded-b-lg"
                      >
                        <span
                          data-v-e313196e
                          className="mr-4 w-4/12 text-12 text-global-font-on-light"
                        >
                          City/State/Country
                        </span>
                        <span
                          data-v-e313196e
                          className="w-8/12 text-12 text-black-600 leading-16px"
                        >
                          {res?.region || "-"}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
              {pagination.hasNextPage && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <button
                    style={{
                      background: "black",
                      color: "white",
                      borderRadius: "5px",
                      padding: "8px",
                    }}
                    onClick={() => myLogData(pagination.page + 1)}
                    disabled={loader}
                  >
                    {loader ? "Loading..." : "Load More"}
                  </button>{" "}
                </div>
              )}
              {logData?.length == 0 && (
                <div
                  data-v-e313196e
                  className="flex justify-center items-center py-48"
                >
                  <div className="pt-6 px-7 pb-5 bg-white text-center text-black-700 text-base rounded-xl leading-tight">
                    <div
                      alt
                      className="icon-empty text-40 text-black-300 m-auto mb-2.5"
                    />
                    <div>No Data</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </VelkieLayout>
  );
};

export default ActivityLog;
